import CardWithFields from "components/General/CardWithFields";
import { getName } from "js/formatting";
import { useTranslation } from "react-i18next";

export default function AnnuitantCard({ annuitants, policyDetail }) {
  const { t } = useTranslation();
  const cardFields = annuitants.reduce((annuitant, currentAnnuitant) => {
    const isPrimary = currentAnnuitant?.person?.partyTypeCode === "IN";
    return [
      ...annuitant,
      {
        title: t("AgentAnnuitantCard-name"),
        value: getName(currentAnnuitant?.person),
      },
      {
        title: t("AgentAnnuitantCard-dob"),
        value: currentAnnuitant?.person.dateofBirth,
      },
      ...(isPrimary
        ? [
            {
              title: t("AgentAnnuitantCard-issue-age"),
              value: policyDetail?.insuredIssueAge,
            },
          ]
        : []),
      {
        title: "", // created empty div. don't remove it.
        value: "", // created empty div. don't remove it.
      },
    ];
  }, []);
  return (
    <CardWithFields
      ariaLabel={t("AgentAnnuitantCard-label")}
      cardTitle={t("AgentAnnuitantCard-title")}
      cardFields={cardFields}
    />
  );
}
